/* La Caza Cali — Hero progress bar
 *
 * Updates .lacaza-hero-progress__fill width as Swiper slides change.
 * Hooks into the existing Swiper instance Nordic creates in slideshow.js.
 *
 * Markup contract (set in sections/slideshow.liquid):
 *   <div class="lacaza-hero-progress" aria-hidden="true">
 *     <div class="lacaza-hero-progress__fill"></div>
 *   </div>
 * sits inside .swiper-controllers__wrapper between the pagination
 * counter and the prev/next arrow buttons.
 */
(function () {
  'use strict';

  function bindHeroProgress() {
    var slideshows = document.querySelectorAll('.slideshow');
    if (!slideshows.length) return;

    slideshows.forEach(function (root) {
      var fill = root.querySelector('.lacaza-hero-progress__fill');
      if (!fill) return;

      // Swiper instance lives on the .swiper element inside .slideshow.
      // It may not be initialized at DOMContentLoaded — poll briefly.
      var swiperEl = root.querySelector('.swiper');
      if (!swiperEl) return;

      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        var s = swiperEl.swiper;
        if (s && typeof s.on === 'function' && s.slides && s.slides.length) {
          clearInterval(iv);
          var update = function () {
            var total = s.slides.length;
            // realIndex correctly accounts for loop mode duplicates;
            // fall back to activeIndex when loop is off.
            var current = (typeof s.realIndex === 'number' ? s.realIndex : s.activeIndex) + 1;
            var pct = Math.max(0, Math.min(100, (current / total) * 100));
            fill.style.width = pct + '%';
          };
          s.on('slideChange', update);
          s.on('slideChangeTransitionEnd', update);
          update();
        } else if (attempts > 40) {
          // Give up after ~4s; fill stays at default 0 width.
          clearInterval(iv);
        }
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeroProgress);
  } else {
    bindHeroProgress();
  }
})();
